import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDesktop = () => {
  return (
    <g>
      <path d="M15 1a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-4.663l.781 1.561h1.163a.72.72 0 1 1 0 1.439H3.719a.72.72 0 1 1 0-1.439h1.162L5.661 12H1a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h14zM8.66 12H7.337l-.781 1.561h2.885L8.66 12zm5.84-9.5h-13v8h13v-8z" />
    </g>
  );
};

export default withIcon(IconDesktop);
